export const env = {
  env: 'local'
};

